module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/6th/mainvisual-date-pc@2x_ae46cc9aae1cc11dea4c6151003f2f4b.png";